import * as S from "./alarmContentItem.styles";
import { ReactComponent as IconAlarm } from "../../../styles/assets/svg/icon-alarm-blue.svg";

interface AlarmContentItemProps {
  dummydata: { header: string; date: string; content: string }[];
}

export const AlarmContentItem = ({ dummydata }: AlarmContentItemProps) => {
  return (
    <S.MainContentsItemLayout>
      {dummydata?.map((dummydata, index) => (
        <S.MainContentsItem key={index}>
          <S.DataHeadBox>
            <S.DataHeadBox className="title">
              <IconAlarm width={22} height={22} />
              <S.StyledText>{dummydata.header}</S.StyledText>
            </S.DataHeadBox>
            <S.ProfileDate>{dummydata.date}</S.ProfileDate>
          </S.DataHeadBox>
          <S.DataItemBox>{dummydata.content}</S.DataItemBox>
        </S.MainContentsItem>
      ))}
    </S.MainContentsItemLayout>
  );
};
